module.exports = __webpack_public_path__ + "static/media/AHP-wh.67b3c0e5.png";